




































































import { Vue, Component, Prop } from "vue-property-decorator";
import Organization from "@/classes/Organization";
import HIVETextField from "@/components/common/HIVETextField.vue";
import HIVEButton from "@/components/common/HIVEButton.vue";
import AccessKey from "@/classes/AccessKey";

@Component({
  components: {
    HIVETextField,
    HIVEButton,
  },
})
export default class CreateUpdateAccessKeysForm extends Vue {
  @Prop(Boolean) public complete: boolean;
  @Prop(Boolean) public isNewOrganization: boolean;
  @Prop(Number) public step: number;
  @Prop(Object) public organization: Organization;
  private imageData: File = null;

  public get accessKeys() {
    return this.$store.getters["organizations/getAccessKeys"];
  }
  private get isComplete() {
    return this.complete;
  }

  private get getOrganization() {
    return this.organization;
  }

  private get getStepNumber() {
    return this.step;
  }

  private get addButtonDisabled() {
    return false;
  }

  private generateAccessKey(accessKey) {
    this.$store.dispatch("organizations/generateAccessKey", accessKey);
  }

  private updateAccessKey(accessKey) {
    this.$store.dispatch("organizations/updateAccessKey", accessKey);
  }

  private created() {
    this.$store.dispatch("organizations/getAccessKeys");
  }
}
